/** @type {import('./translationTypes.js').Translations} */
const translations = {
	local: {
		region: 'fr-FR',
		language: 'Langue',
		passedTimeInstant: "à l'instant",
		passedTime1: 'il y a ',
		passedTime2: '',
		minute: 'minute(s)',
		hour: 'heure(s)',
		day: 'jour(s)'
	},
	homepage: {
		title: 'Legal OS',
		tagline:
			'Accédez à des réponses juridiques fiables en un instant. Rédigez, analysez et maîtrisez vos documents avec une précision et une rapidité inégalées.',
		tryOrdalie: 'Essayez Ordalie',
		contactUs: 'Contactez-nous',
		kpi1title: '100% hébergé en France',
		kpi1content:
			'Vos données restent strictement en France et ne sont jamais réutilisées pour entraîner nos modèles.',
		kpi2title: '8h gagnées en moyenne par semaine/personne',
		kpi2content:
			"Les entreprises et cabinets clients d'Ordalie constatent un vrai gain de temps significatif et durable.",
		kpi3title: '+2 Millions de sources officielles et fiables',
		kpi3content:
			"Ordalie s'appuie uniquement sur des sources juridiques certifiées : codes, lois, jurisprudence, BOFiP, CNIL… mises à jour quotidiennement.",

		card1title: 'Ancrage juridique permanent',
		card1content:
			'Toutes les tâches sont supervisées par une constante analyse au regard des sources juridiques officielles, mises à jour quotidiennement.',
		card1animation: '/animations/anim-1-sources-FR.json',
		card2title: 'Connectez Ordalie à votre knowledge',
		card2content: "La valeur d'Ordalie est multipliée par vos années d'expérience et d'archives.",
		card2animation: '/animations/anim-3-vault-FR.json',
		card3title: 'Génération automatisée sur-mesure',
		card3content:
			'Créez rapidement des documents juridiques personnalisés et précis en quelques clics.',
		card3animation: '/animations/anim-2-gen-FR.json',
		securitySectionTitle: 'PRIORITÉ À LA SÉCURITÉ',
		securitySectionContent: `La sécurité de vos données est notre priorité chez Ordalie. <span class="font-rethink font-medium">Hébergées en France<sup>➀</sup></span>, nos infrastructures sont conformes au <span class="font-rethink font-medium">RGPD<sup>➁</sup></span> et répondent aux normes <span class="font-rethink font-medium">SOC II<sup>➂</sup></span> et <span class="font-rethink font-medium">ISO 27001<sup>➃</sup></span>, garantissant une protection avancée et une sécurité continue de vos informations sensibles.`,
		outlineFig: 'Chiffres clés',
		outlineFeatures: 'Fonctionnalités',
		outlineUsers: 'Utilisateurs',
		outlineSecurity: 'Sécurité',
		outlineResources: 'Ressources',
		contactUsToLearnMore: 'Contactez-nous pour en savoir plus'
	},
	user: {
		you: 'Vous',
		unknown: 'Inconnu',
		loginOrSignup: 'Connexion | Inscription',
		login: 'Connexion',
		logout: 'Déconnexion',
		logoutConfirmation: 'Êtes-vous sûr de vouloir vous déconnecter ?',
		signup: 'Inscription',
		successLogin: 'Connexion réussie',
		sendingMagicLink: 'Envoi du lien de connexion...',
		magicLinkSent: 'Lien de connexion envoyé',
		verifyingLogin: 'Vérification de la connexion...',
		signingInWith: 'Connexion avec {provider}...',
		expiredToken: 'La connexion a expiré, veuillez vous reconnecter.',
		updateMsg: 'Vos informations ont été mises à jour',
		profile: 'Votre Profil',
		organization: 'Organisation',
		connectedOrganization: 'Organisation connectée',
		organizationBenefits: "Avantages de l'organisation",
		orgBenefit1: "Accès sécurisé au coffre-fort de données de l'organisation",
		orgBenefit2: "Collaboration fluide avec les membres de l'équipe",
		orgBenefit3: 'Gestion et partage avancés des documents',
		orgBenefit4: 'Base de connaissances centralisée',
		supportContact: 'Pour toute question ou support, contactez :',
		onPremiseVersion: 'Version on-premise pour les entreprises',
		profileMsg:
			"Ces informations me permettront de mieux comprendre vos attentes et d'adapter mes réponses à votre profil 📝",
		name: 'Nom',
		description: 'Description',
		askForConnection: 'Connectez-vous pour accéder à cette fonctionnalité.',
		haveAccessToFunctionality: "Vous avez accès à cette fonctionnalité !'",
		editProfile: 'Modifier mon profil',
		subAndBilling: 'Abonnement & facturation',
		handleBilling: 'Gérer ma facturation',
		myCustomerSpace: 'Mon espace client',
		customerSpace: 'Espace client',
		manageSubscription: 'Gérer mon abonnement',
		subscriptionPaused: 'Abonnement en pause 🔔',
		subscriptionPausedMsg1:
			"Votre abonnement Ordalie est en pause car nous n'arrivons pas à utiliser le moyen de paiement lié à votre abonnement.",
		subscriptionPausedMsg2:
			'Veuillez vérifier vos informations de paiement dans votre espace client.',
		editLanguage: 'Langue',
		editLanguageMsg:
			"Choisissez la langue dans laquelle vous souhaitez recevoir les réponses d'Ordalie.",
		settings: 'Paramètres',
		loginToOrdalie: 'Connexion à Ordalie',
		signupToOrdalie: 'Accédez à Ordalie',
		signupMsg1: 'Connectez-vous pour accéder à ',
		signupMsg2: 'Si vous avez déjà un compte, vous y serrez automatiquement redirigé.',
		signupMsg3: 'En poursuivant, vous acceptez nos',
		signupMsg4: "conditions générales d'utilisation",
		signupMsg5: 'et notre',
		signupMsg6: 'politique de confidentialité',
		loginWithGoogle: 'Connexion avec Google',
		loginWithMicrosoft: 'Connexion avec Microsoft',
		or: 'ou',
		loginWithEmail: 'Connexion avec email',
		almostThere: 'Vous y êtes presque !',
		almostThereMsg1: 'Nous vous avons envoyé un mail contenant un lien de connexion éphémère',
		almostThereMsg2: "Jetez un coup d'oeil aux spams si vous ne voyez rien",
		openGmail: 'Ouvrir Gmail',
		openOutlook: 'Ouvrir Outlook',
		welcomePro: 'Bienvenue sur Ordalie PRO ! 🎉',
		alreadyPro: 'Vous êtes déjà abonné(e) à Ordalie PRO 🎉',
		canceledPayment: 'Le paiement a bien été annulé.',
		companySize: "Taille d'entreprise",
		currentPlan: 'Plan actuel',
		open: 'Ouvrir',
		upgradeToPro: 'Passez sur Ordalie Pro',
		learnMore: 'En savoir plus',
		createOrganization: 'Créer une organisation',
		organizationName: "Nom de l'organisation",
		organizationNamePlaceholder: 'Entrez le nom de votre organisation',
		organizationDescriptionPlaceholder: 'Entrez une description pour votre organisation',
		billingEmail: 'Email de facturation',
		addBillingEmail: 'Ajouter un email de facturation',
		addBillingEmailDesc:
			'Ajoutez un email de facturation pour recevoir les mises à jour de votre abonnement et vos factures',
		billingEmailUpdated: 'Email de facturation mis à jour avec succès',
		subscribeImmediately: "S'abonner immédiatement",
		organizationTip:
			'Créez une organisation pour collaborer avec votre équipe et gérer vos documents ensemble.',
		organizationCreated: 'Organisation créée avec succès',
		inviteMember: 'Inviter un membre',
		inviteSent: "L'invitation a été envoyée avec succès",
		inviteAccepted: "L'invitation a été acceptée avec succès",
		confirmRemoveMember: 'Êtes-vous sûr de vouloir retirer ce membre ?',
		memberRemoved: 'Membre retiré avec succès',
		roleUpdated: 'Rôle mis à jour avec succès',
		organizationUpdated: 'Organisation mise à jour avec succès',
		billingManagement: 'Gestion de la facturation',
		billingDescription:
			'Gérez votre abonnement et vos informations de facturation dans le portail client.',
		accessBillingPortal: 'Accéder au portail de facturation',
		details: 'Détails',
		members: 'Membres',
		billing: 'Facturation',
		roleAdmin: 'Administrateur',
		roleMember: 'Membre',
		roleViewer: 'Observateur',
		user: 'Utilisateur',
		role: 'Rôle',
		noOrganization: 'Aucune Organisation',
		noOrganizationDesc:
			'Créez une organisation pour commencer à collaborer avec votre équipe et gérer vos projets ensemble.',
		preferences: 'Préférences',
		integrations: 'Intégrations',
		// Account Information section
		accountInformation: 'Informations du compte',
		profilePicture: 'Photo de profil',
		uploadPhoto: 'Télécharger une photo',
		photoRequirements: 'JPG, GIF ou PNG. 1Mo max.',
		photoConsentTitle: 'À propos de votre photo',
		photoConsentMessage:
			"Votre photo sera visible publiquement en tant qu'avatar par les autres utilisateurs, uniquement sur les contenus que vous choisissez de partager.",
		agreeAndUpload: 'Continuer',
		uploadingPhoto: 'Téléchargement de votre photo...',
		photoUploaded: 'Photo téléchargée avec succès',
		deletingPhoto: 'Suppression de votre photo...',
		photoDeleted: 'Photo supprimée avec succès',
		nameDisplayed: "Votre nom tel qu'affiché aux autres utilisateurs.",
		emailContact: 'Contactez le support pour changer votre adresse email.',
		briefDescription: 'Brève description pour votre profil.',
		// Company Information section
		companyInformation: "Informations de l'entreprise",
		companyRecommendations: 'Cela nous aide à adapter nos recommandations à vos besoins.',
		// Subscription section
		planComparison: 'Comparaison des plans',
		features: 'Fonctionnalités',
		free: 'Gratuit',
		pro: 'Pro',
		currentPlanLabel: 'Plan actuel',
		recommended: 'Recommandé',
		documentStorage: 'Stockage de documents',
		aiQueries: 'Requêtes IA',
		searchCapabilities: 'Capacités de recherche',
		externalIntegrations: 'Intégrations externes',
		teamCollaboration: "Collaboration d'équipe",
		support: 'Support',
		limited: 'Limité',
		unlimited: 'Illimité',
		noRestrictions: 'Sans restrictions',
		basic: 'Basique',
		advanced: 'Avancé',
		standard: 'Standard',
		community: 'Communauté',
		priority: 'Prioritaire',
		responseTime: 'Temps de réponse 24h',
		current: 'Actuel',
		premium: 'Premium',
		upgradeNow: 'Passer à Pro',
		testimonialQuote:
			'"Passer à Pro a fait gagner à notre équipe d\'innombrables heures sur la recherche juridique et la préparation de documents. L\'accès illimité et les fonctionnalités avancées ont été inestimables pour notre flux de travail."',
		testimonialAuthor: '— Sarah J., Consultante juridique',
		// Manage Subscription section
		subscription: 'Abonnement',
		manageSubscriptionTitle: "Gérer l'abonnement",
		// Free Plan Details
		freePlanIncludes: 'Votre plan gratuit inclut :',
		basicDocumentStorage: "Stockage de documents basique (jusqu'à 100Mo)",
		standardSearchCapabilities: 'Capacités de recherche standard',
		communitySupport: 'Support communautaire',
		upgradeToUnlock: 'Passez à Pro pour débloquer :',
		unlimitedDocumentStorage: 'Stockage de documents illimité',
		advancedAISearch: 'Recherche et analyses avancées par IA',
		prioritySupport: 'Support prioritaire avec temps de réponse de 24h',
		// Pro Plan Details
		billingPeriod: 'Période de facturation',
		monthly: 'Mensuel',
		nextBillingDate: 'Prochaine date de facturation',
		paymentMethod: 'Moyen de paiement',
		allPremiumFeatures: 'Toutes les fonctionnalités premium débloquées',
		yearlyPlanActive: 'Votre abonnement annuel est actif',
		monthlyPlanActive: 'Votre abonnement mensuel est actif',
		subscriptionAccessInfo:
			'Vous avez accès à toutes les fonctionnalités premium. Gérez votre abonnement ou vos détails de facturation via votre portail client.',
		noActiveSubscription: 'Aucun abonnement actif',
		subscribeToUnlockFeatures:
			'Abonnez-vous pour débloquer toutes les fonctionnalités premium et améliorer votre expérience.',
		yearly: 'Annuel',
		subscriptionActive: 'Abonnement actif',
		// Integrations section
		connectedServices: 'Services connectés',
		proFeature: 'Fonctionnalité Pro',
		proFeatureLimited: 'Fonctionnalité Pro Limitée',
		connectAccounts:
			'Connectez vos comptes pour importer et synchroniser vos documents automatiquement.',
		upgradeForIntegrations: "Passez à Pro pour des capacités d'intégration complètes.",
		microsoft: 'Microsoft',
		google: 'Google',
		disconnected: 'Déconnecté',
		connect: 'Connecter',
		requiresProPlan: 'Nécessite le plan Pro',
		microsoftServices: 'Connectez-vous à OneDrive, SharePoint et autres services Microsoft.',
		googleServices: 'Connectez-vous à Google Drive, Gmail et autres services Google.',
		// Coming Soon section
		comingSoon: 'Bientôt disponible',
		dropbox: 'Dropbox',
		slack: 'Slack',
		notion: 'Notion',
		syncDropbox: 'Synchronisez vos fichiers Dropbox',
		connectSlack: 'Connectez-vous à votre espace de travail Slack',
		importNotion: 'Importez depuis les bases de données Notion',
		// Language & Region section
		languageRegion: 'Langue et région',
		chooseLanguage: "Choisissez votre langue préférée pour l'interface.",
		// Appearance section
		appearance: 'Apparence',
		darkMode: 'Mode sombre',
		toggleTheme: 'Basculer entre les thèmes clair et sombre',
		toggleThemeButton: 'Changer de thème',
		// Tutorials & Help section
		tutorialsHelp: 'Tutoriels et aide',
		resetTutorials:
			'Réinitialisez tous les conseils et guides des tutoriels pour les voir à nouveau.',
		resetTutorialsButton: 'Réinitialiser les tutoriels',
		// Security section
		security: 'Sécurité',
		mfaIntro: 'Ajoutez une couche de sécurité supplémentaire à votre compte.',
		enableMfa: 'Activer la 2FA',
		disableMfa: 'Désactiver la 2FA',
		mfaCode: 'Code de vérification',
		mfaVerificationInfo: 'Saisissez le code à 6 chiffres de votre application d\'authentification.',
		mfaSetupInfo: 'Scannez le QR code avec votre application d\'authentification, puis saisissez le code généré.',
		mfaEnabled: 'Authentification à deux facteurs activée',
		mfaDisabled: 'Authentification à deux facteurs désactivée',
		mfaEnabledInfo: 'Votre compte est protégé par l\'authentification à deux facteurs. Vous devrez saisir un code de votre application d\'authentification à chaque connexion.',
		mfaDisabledInfo: 'Activez l\'authentification à deux facteurs pour ajouter une couche de sécurité supplémentaire à votre compte.',
		multifactorAuth: 'Authentification à deux facteurs',
		mfaDescription: 'Protégez votre compte avec une seconde couche de sécurité en utilisant une application d\'authentification.',
		enabled: 'Activé',
		disabled: 'Désactivé',
		// Admin section
		apiConfiguration: "Configuration de l'API",
		apiRootURL: "URL racine de l'API",
		advancedSettings: 'Paramètres avancés',
		adminSettingsInfo:
			"Des paramètres et outils d'administration supplémentaires apparaîtront ici.",
		active: 'Actif',
		inactive: 'Inactif'
	},
	label: {
		chat: 'Assistant',
		documents: 'Documents',
		write: 'Générateur de documents',
		search: 'Bibliothèque',
		analyze: 'Analyse multi-documents',
		notes: 'Notes',
		settings: 'Paramètres',
		myAccount: 'Compte',
		training: 'Apprendre',
		darkMode: 'Mode sombre',
		lightMode: 'Mode clair',
		menu: 'Menu',
		recentConversations: 'Conversations récentes',
		recentDocuments: 'Documents récents',
		noDocuments: 'Aucun document',
		noNotes: 'Aucune note',
		noConversations: 'Aucune conversation',
		productUpdates: 'Mises à jour du produit',
		updates: 'Mises à jour',
		feedbackRequest:
			'Vous avez des idées pour améliorer Ordalie ? N\'hésitez pas à <a href="mailto:support@ordalie.com?subject=Feature%20Suggestion" class="text-royal-blue hover:text-royal-blue/80 font-medium">nous écrire</a>, on adore avoir vos retours !',
		feedbackSignature: "L'équipe Ordalie"
	},
	status: {
		trial: 'Essai',
		late: 'Retard',
		free: 'Free',
		becomePro: 'Passez à Ordalie Pro',
		monthly: 'Mensuel',
		yearly: 'Annuel',
		vatExcluded: "Tous les prix sont en EUR et n'incluent pas la TVA"
	},
	offer: {
		pricingTitle: 'Clair, flexible et toujours juste.',
		pricingSubtitle: "Accédez à l'assistant juridique IA le plus avancé, adapté à vos besoins",
		freeForever1: 'Gratuit',
		freeForever2: 'pour toujours',
		freeIntro: 'Commencez ici',
		actualOffer: 'Offre actuelle',
		freeAIModel: "Modèles d'IA basiques",
		freeQueries: '10 requêtes / semaine',
		freeHistoricalRecords: 'Historique de 7 jours',
		freeSearchEngine: 'Accès au moteur de recherche',

		freeCreateNotes: 'Création de notes',
		proTitle: 'Ordalie PRO',
		proSubtitle: 'Pour les professionnels',
		proIntro: 'IA juridique avancée',
		proPriceCondition: 'TTC/mois/utilisateur',
		proSouscriptionButton: 'Passer PRO',
		cancelAnytime: 'Sans engagement',

		proAIModel: "Modèles d'IA avancés",
		proQueries: 'Requêtes illimitées',
		proHistoricalRecords: 'Historique illimité',
		proSearchEngine: 'Moteur de recherche avancé',
		proCreateNotes: 'Création de notes avancée',
		proImportDocuments: 'Importez vos propres documents',
		proGenerateContracts: 'Générez tous vos contrats',
		proAnalyseDocuments: 'Analyse juridique détaillée',
		enterpriseTitle: 'Solution Sur-mesure',
		enterpriseSubtitle: 'Ordalie Vault',
		enterpriseContact: 'Contactez-nous',
		enterpriseFeatures: 'Tout ce qui est inclus dans Pro',
		enterpriseOnPremise: 'Déploiement sur vos serveurs avec contrôle total de vos données',
		enterpriseAI: 'Exploitation de vos documents par IA',
		enterpriseVolume: 'Tarifs dégressifs selon le volume',
		enterpriseManager: 'Manager dédié',
		enterpriseOnboarding: 'Onboarding personnalisé',
		enterpriseSupport: 'Support prioritaire',
		customizedNeed1: 'Pour des besoins sur-mesure, ',
		customizedNeed2: 'contactez-nous',
		subscriptionSuccess: 'Bienvenue sur Ordalie Pro 🎉',
		thanksForSubscription: 'Merci pour votre confiance !',
		alreadyPro: 'Vous êtes déjà abonné 🎉'
	},
	chat: {
		greetingDay: 'Bonjour',
		greetingNight: 'Bonsoir',
		introduction:
			"Je suis Ordalie, une IA juridique française. J'ai accès à des millions de sources juridiques (codes, lois, jurisprudences, AAI...). \nPosez-moi des questions ou demandez moi de rédiger des documents !",
		appelForInscription: "Inscrivez-vous simplement d'abord pour parler avec moi.",
		callForPro1:
			'Je ne remplace pas un professionnel du droit, vérifiez bien les informations avant de les utiliser. \nEnvisagez ',
		callForPro2: 'pour plus de fiabilité et de sécurité.',
		tryPro: 'Essayer Pro',
		disclaimer:
			'Ordalie peut faire des erreurs. Envisagez de vérifier les informations importantes.',
		freeGoPro:
			'Vous êtes sur notre version gratuite. <a class="text-royal-blue contrast-200 cursor-pointer hover:underline" onclick={window.handleProClick()}>Passez PRO</a>',
		conversations: 'Conversations',
		conversationSingle: 'Conversation',
		historyConversations: 'Historique',
		archiveConversation: 'Archiver la conversation',
		deleteConversation: 'Supprimer la conversation',
		deleteConversationContent: 'Êtes-vous sur de vouloir supprimer cette conversation ?',
		newConversation: 'Nouvelle conversation',
		renameConversation: 'Renommer la conversation',
		deleteMessage: 'Supprimer le message',
		deleteMessageConfirmation: 'Êtes-vous sur de vouloir supprimer ce message ?',
		deleteAnalysis: "Supprimer l'analyse",
		deleteAnalysisConfirmation: 'Voulez-vous vraiment supprimer cette analyse ?',
		copyWithSources: 'Copier la réponse avec les sources',
		includeQuestion: 'Inclure la question',
		includeJustification: 'Inclure la justification',
		dislike: 'Évaluation négative',
		like: 'Évaluation positive',
		messageOptions: 'Options du message',
		noData: 'Aucune donnée',
		inputLabel: 'Zone de texte',
		inputPlaceholderSearch:
			'Dites-moi ce dont vous avez besoin…... (@ pour mentionner un document)',
		inputPlaceholderAnalysis:
			'Posez une question sur vos documents... (@ pour mentionner un document)',
		inputPlaceholderWrite:
			'Décrivez le(s) document(s) à générer... (@ pour mentionner un document)',
		dropToAttach: 'Glisser le document ici',
		seeBeginning: 'Voir le début de la conversation',
		error: 'Une erreur est survenue. Réessayez ou reformulez votre question.',
		login: 'Veuillez vous connecter pour parler à Ordalie.',
		limitReached:
			"Vous avez atteint la limite de 10 messages par semaine 😗\n Passez à **Ordalie Pro** pour bénéficier de messages illimités et d'une IA plus performante.",
		// <br> <button class='px-8 py-1 rounded-lg bg-ord-blue text-md  mt-4 h-12 font-medium' onclick={window.handleProClick()}>Ordalie Pro</button>
		docGenerated: 'Voici votre document généré :',
		archivedConversationsMsg: 'Vos conversations passées apparaîtront ici !',
		noArchivedConversationsMsg1: 'Aucune conversation liée au terme "',
		noArchivedConversationsMsg2: '" 😢',
		limitArchivedConversations1: 'Vous êtes limité aux 7 derniers jours de conversations.',
		limitArchivedConversations2: 'Passez à',
		limitArchivedConversations3: 'pour un historique illimité.',
		limitConversationsAtteinte:
			'Limite atteinte. Passez à Ordalie PRO pour une expérience illimitée.',
		exportToXLSX: 'Exporter en Excel',
		usedConversations: '/10 requêtes effectuées',
		chatloadingMsg1: 'Compréhension de la demande',
		chatloadingMsg2: 'Prise en compte du contexte',
		chatloadingMsg3: 'Rédaction de la réponse',
		writeQuestion: 'Écrivez votre question',
		exportAnswer: 'Copier la réponse (avec sources)',
		exporterAsPDF: 'Exporter en PDF',
		exporterAsWord: 'Exporter en Word',
		exportInProgress: 'Export en cours...',
		exportSuccessful: 'Export réussi',
		question: 'Question',
		answer: 'Réponse',
		searching: 'Recherche en cours...',
		results: 'Résultats',
		all: 'Tout',
		search: 'Recherche',
		documentNotFound: 'Document non trouvé',
		errorDocumentNotFoundMsg: 'Le document demandé est introuvable',
		errorLoadingDocument: 'Erreur lors du chargement du document',
		errorLoadingShortMsg: 'Erreur de chargement',
		processingDocument: 'Le document est en cours de traitement',
		loadingShortMsg: 'Chargement...',
		generatingShortMsg: 'Génération...',
		editingShortMsg: 'Édition du document...',
		readyShortMsg: 'Prêt',
		untitled: 'Sans titre',
		thinkingTitle: 'Raisonnement...'
	},
	sources: {
		sources: 'Sources',
		userDocuments: 'Mes documents',
		userDocumentsSubtitle: 'Retrouvez ici tous les documents que vous avez générés et importés.',
		documents: 'Documents',
		singleSource: 'Source',
		internalSources: 'Sources internes',
		activeSources: 'sources actives',
		manageSources: 'Gérer les sources',
		tableType: 'Tableau',
		annexType: 'Annexe',
		articleType: 'Article',
		addUrlSourceMsg: "Entrez l'URL du site internet à ajouter à vos sources",
		addSitesMsg: "Ajoutez vos sites internet préférés aux sources d'Ordalie 👆",
		apiaddDocumentMsg: "Ajouter vos propres documents aux sources d'Ordalie 🔒",
		apiworkingOnDocumentsMsg: 'Travaillez sur vos propres documents dans Ordalie 🔒',
		sourceAlreadyAdded: 'Cette source est déjà ajoutée',
		addSourceSuccess: 'Source ajoutée',
		sourceLinkInaccesible: "Le lien est inaccessible ou n'est pas valide.",
		addContentToContext: 'Ajoutez du contenu au contexte',
		chooseDocuments: 'Choisissez des documents',
		chosedDocuments: 'Documents sélectionnés',
		chosedDocumentSingle: 'Document sélectionné',
		importDocument: 'Importer un document',
		importDocuments: 'Importer des documents',
		importDocumentSuccess: ' a été importé',
		importDocumentsMsg: 'Glisser vos documents à analyser ici',
		noDocuments: "Vous n'avez pas encore de documents",
		noResults: 'Aucun résultat',
		emptyFolder: 'Le dossier est vide',
		chosedSources: 'Sources sélectionnées',
		chosedSourceSingle: 'Source sélectionnée',
		selectAll: 'Tout sélectionner',
		deselectAll: 'Tout désélectionner',
		documentName: 'Nom',
		documentDate: 'Date',
		documentActions: 'Actions',
		addDocumentMsg: 'Ajoutez vos documents dans un espace sécurisé sur Ordalie 🔒',
		addDocumentMsg2: 'Vos documents sont sécurisés et accessibles <u>uniquement par vous</u>.',
		addDocument: 'Ajouter un document',
		addDocumentToSources: 'Ajout de source',
		addDocumentSuccess: 'a été ajouté',
		addingDocument: 'Ajout du document...',
		addingDocumentSuccessMsg:
			'Vous pouvez quitter cet écran, vous le retrouverez dans vos documents',
		addToSources: 'Ajouter aux sources',
		addToDocument: 'Ajout de document',
		addToDocumentMsg: 'Voulez-vous attacher ce texte en tant que document à analyser ?',
		removeFromSources: 'Retirer des sources',
		addDocumentToSourcesMsg: 'Voulez vous ajouter ce document à la recherche ?',
		addDocumentToSourcesSubtext: 'Seule la version actuelle sera ajoutée aux sources.',
		renameDocument: 'Renommer le document',
		addTag: 'Ajouter un tag',
		addTagMsg:
			'Les tags vous permettent de trier vos documents. Ajoutez en autant que vous le souhaitez.',
		tags: 'Tags',
		createNew: 'Nouveau tag',
		tagsAddedSuccess: 'Tags ajoutés',
		tagsRemovedSuccess: 'Tag supprimé',
		searchTags: 'Rechercher des tags ou documents...',
		clickToView: 'Cliquer pour voir les documents',
		removeDocumentConfirmation: 'Supprimer le(s) document(s) ?',
		removeDocumentAlert: 'Cette action est irréversible.',
		removeDocumentSuccess: 'Document supprimé',
		removeDocumentFromSources: 'Retrait de source',
		removeDocumentFromSourcesMsg: 'Voulez vous retirer ce document des sources de recherche ?',
		removeDocumentFromSourcesSucess: 'Le document a été supprimé des sources',
		addDocumentToSourcesSuccess: 'Le document a été ajouté aux sources',
		documentAlreadyAdded: 'Ce document a déjà été ajouté',
		pleaseAddDocumentsToAnalyze: 'Ajoutez des documents à analyser',
		removeUrlSource: 'Retirer de source',
		removeUrlSourceConfirmation: 'Voulez-vous vraiment retirer cette source ?',
		removeSearchSource: 'Retrait de source',
		removeSearchSourceConfirmation: 'Voulez vous retirer ce document des sources de recherche ?',
		removeSearchSourceSuccess: 'Le document a été supprimé des sources',
		sourcesOfOrdalie: "Sources d'Ordalie",
		sourcesOfOrdalieMsg1: 'Ordalie se fonde sur des millions de sources constamment à jour.',
		sourcesOfOrdalieMsg2: 'Vous pouvez compléter ces sources avec ',
		sourcesOfOrdalieMsg3: 'vos propres documents',
		sourcesOfOrdalieMsg4: ' (dans un espace entièrement cloisonné) ou bien ',
		sourcesOfOrdalieMsg5: 'indexer des sites internet',
		sourcesOfOrdalieMsg6: ' que vous consultez régulièrement.',
		chooseSourcesMsg:
			"Sélectionnez les différentes sources sur lesquelles vous souhaitez qu'Ordalie se fonde pour vous répondre.",
		sourcesFromInternet: 'Sites internet',
		callForProForMoreSources: 'Vous devez avoir PRO pour ajouter plus de 2 sources.',
		callForProForAddDocuments: 'Vous devez avoir PRO pour ajouter vos documents aux sources',
		legalSources: 'Sources juridiques',
		codesSources: 'Codes',
		expand: 'Développer',
		generateWithAI: "Générer avec l'IA",
		limitDocuments: 'Vous avez atteint la limite de documents pour votre compte gratuit',
		newDocument: 'Nouveau document',
		documentGeneratedMsg1:
			'Dans cette section vous retrouverez tous les documents rédigés avec Ordalie.',
		documentGeneratedMsg2: 'Vous pourrez aussi rédiger de nouveaux documents.',
		searchSources: 'Recherche documentaire',
		recentSearches: 'Recherches récentes',
		activateSource: 'Activer',
		deactivateSource: 'Désactiver',
		resetSearch: 'Réinitialiser la recherche',
		sourcesNumber: 'élément(s)',
		downloadDocument: 'Télécharger le document',
		downloadAnonymizeDocument: 'Anonymiser le document',
		downloadDocumentSuccess: 'Document téléchargé',
		removeFromList: 'Retirer de la liste',
		documentTitle: 'Titre du document',
		pinSource: 'Épingler la source',
		noResultsFor: 'Aucun résultat pour',
		repealed: 'Abrogé',
		amended: 'Modifié',
		inForce: 'En vigueur',
		indent: 'Augmenter le retrait',
		outdent: 'Diminuer le retrait',
		noTags: 'Aucun tag',
		noTagsTitle: 'Organisez avec des tags',
		noTagsSubtitle: 'Commencez par rechercher et taguer votre premier document',
		noTagsFeature1: 'Regroupez documents et sources sous le même tag',
		noTagsFeature2: 'Référencez dans le chat en utilisant',
		noTagsFeature3: 'Suivez vos dossiers, affaires ou sujets de recherche',
		createTagsDescription:
			'Créez des tags pour organiser vos documents et les retrouver plus facilement.',
		noDocumentsWithTag: 'Aucun document avec ce tag',
		addTagToDocuments: 'Ajoutez ce tag à vos documents pour les retrouver ici.',
		tagDeleted: 'Tag supprimé',
		errorDeletingTag: 'Erreur lors de la suppression du tag',
		document: 'Document',
		documentUploadedSuccess: 'Document téléchargé avec succès',
		documentUploadedError: 'Erreur lors du téléchargement du document',
		sharedWithYou: 'Partagé avec vous'
	},
	notes: {
		notes: 'Notes',
		noteSingle: 'Note',
		userNotes: 'Mes notes',
		notesMsg1: 'Retrouvez ici toutes vos notes et sources épinglées',
		notesMsg2: 'Pour ajouter une note, cliquez simplement sur le bouton ',
		notesMsg3:
			"sur une source (article, jurisprudence, etc.). Vous aurez également la possibilité d'ajouter un texte directement dans la note.",
		searchForNotes: 'Lancer une recherche',
		error: 'Une erreur est survenue lors du chargement des notes. Veuillez réessayer.',
		deleteNoteConfirmation: 'Voulez-vous supprimer cette note ?',
		notePlaceholder: 'Écrivez votre note ici...',
		removeAllTags: 'Supprimer tous les tags',
		removeAllTagsConfirmation1: 'Voulez-vous vraiment supprimer tous les tags sous le label « ',
		removeAllTagsConfirmation2: ' » ?',
		removeAllTagsSuccess1: 'Tous les tags (',
		removeAllTagsSuccess2: ') ont été supprimés',
		removeAllTagsError: 'Erreur lors de la suppression des tags',
		removeAllTagsAlert: 'Cette action est irréversible.',
		rightClickToDelete: 'Clic droit pour supprimer'
	},
	writing: {
		intent: 'écris|rédige|ecris|redige',
		aiWriting: 'Écriture IA',
		aiEdit: 'Édition IA',
		aiRewrite: 'Réécriture IA',
		aiAssistant: 'Assistant IA',
		textEditor: 'Éditeur de texte',
		textEditorAria: 'Modifier, améliorer ou générer du texte',
		writing: 'Écriture',
		generate: 'Générer la suite',
		insert: 'Insérer',
		passage: 'Passage',
		generateFromPassage: 'Générer à partir du passage',
		rewriteWithContext: 'Réécrire à partir du passage',
		reformulation: 'Reformulation',
		fluidize: 'Améliorer la fluidité',
		correction: 'Correction',
		shorten: 'Raccourcir',
		develop: 'Développer',
		rewriteInTable: 'Retranscrire en tableau',
		correctSpelling: "Corriger l'orthographe",
		restart: 'Recommencer',
		replace: 'Remplacer',
		insertBelow: 'Insérer en dessous',
		inspireRewrite: "S'inspirer pour réécrire",
		similarPassages: 'Passages similaires',
		selectedText: 'Texte sélectionné',
		selectionTooLong: 'Sélection trop longue',
		searchSimilarPassages: 'Passages similaires',
		seeSimilarPassagesMsg1: 'Voir ',
		seeSimilarPassagesMsg2: ' passage(s) similaire(s)',
		pleaseSelectAPassage: 'Veuillez sélectionner un passage à analyser',
		createYourFirstAnalysis: 'Créez votre première analyse',
		clearAll: 'Tout effacer',
		bold: 'Gras',
		italic: 'Italique',
		underline: 'Souligné',
		generation: 'Génération...',
		instructionForWriting: "Instruction d'écriture...",
		instructionForRewrite: 'Instruction de réécriture...',
		aiAnalyze: 'Analyse IA',
		analyzePassageWithAI: "Analyser le passage avec l'IA",
		describeDocumentToGenerate: 'Veuillez décrire le document à générer',
		documentGeneration: 'Génération de documents',
		documentGeneratePlaceholder:
			'Ex: Contrat de prestation de services, NDA... (@ pour lier un document)',
		documentModel: 'Modèle de document',
		addDocumentModel: 'Ajouter un modèle de document',
		generateDocument: 'Générer le document',
		generateAllDocuments: 'Générer tous les documents',
		generateBrief: 'Générer le brief',
		documentBrief: 'Brief du document...',
		documentStructure: 'Structure du document',
		modificationMsg: 'Vous pouvez modifier tous les textes du brief, et réordonner les parties.',
		templates: "Modèles d'analyse",
		useTemplate: 'Utiliser un modèle',
		newTemplate: 'Nouveau modèle',
		newTemplateMsg: "Cliquez sur <i>Nouveau modèle</i> pour créer une nouvelle chaîne d'analyses !",
		analysisTemplateTitle: 'Titre du modèle',
		analysisPromptMsg: "Ajoutez des questions à votre modèle. Elles seront posées dans l'ordre.",
		deleteTemplateSuccess: 'Le modèle a été supprimé',
		loadedTemplate: 'Template chargé',
		invalidDocumentStructure: 'Structure de document invalide.',
		showStructure: 'Afficher la structure',
		describeRewrite: 'Décrivez comment vous souhaitez réécrire le texte sélectionné',
		describeWrite: 'Décrivez ce que vous souhaitez écrire'
	},
	comment: {
		addComment: 'Ajouter un commentaire',
		replyToThread: 'Répondre au fil de discussion'
	},
	summary: {
		summary: 'Résumé',
		disclaimer: 'Ce résumé a été généré par IA, il peut contenir des erreurs.'
	},
	analyses: {
		analysis: 'Analyse',
		analyses: 'Analyses',
		summary: 'Synthèse',
		dateAndDelays: 'Dates et délais',
		attentionPoints: "Points d'attention",
		partiesPrenantes: 'Parties prenantes',
		beginner: 'Néophyte',
		intermediate: 'Intermédiaire',
		advanced: 'Avancée',
		expert: 'Experte',
		passageNotFound: "Le passage cité n'existe plus dans le document"
	},
	error: {
		generalError: 'Une erreur est survenue.',
		generalErrorMsg: 'Une erreur est survenue',
		generalErrorTryLaterMsg: 'Une erreur est survenue, veuillez essayer ultérieurement.',
		invalidMagicLink: "Le lien n'est pas valable, veuillez réessayer.",
		invalidMfaCode: 'Le code est incorrect.',
		errorLoadingConversation: 'Erreur de chargement de la conversation.',
		errorLoadingConversationMsg: 'Une erreur est survenue lors du chargement de la conversation.',
		documentNotFound: 'Document non trouvé',
		retry: 'Essayer à nouveau',
		resend: 'Renvoyer',
		errorLoadingShortMsg: 'erreur de chargement',
		errorFetchDocument: 'Impossible de récupérer le document',
		errorFetchComments: 'Impossible de récupérer les commentaires',
		errorGenerateDocument: 'Une erreur est survenue lors de la génération du document',
		errorDownloadDocument: 'Erreur lors du téléchargement',
		errorSearchSources: 'Erreur lors de la recherche de sources',
		errorFreeDocLimitReached: 'Vous avez atteint la limite de documents pour votre compte gratuit',
		errorDocLimitReached: 'Vous avez atteint la limite de documents',
		errorImportDocument: "Erreur : impossible d'importer ce(s) document(s)",
		errorEmailNotValid: 'Veuillez entrer une adresse mail valide',
		errorNotLogged: 'Vous devez être connecté pour accéder à cette fonctionnalité',
		errorLoadingSource: "Nous n'avons pas réussi à récupérer cette source :/",
		errorDocumentNotFound: 'Document introuvable',
		errorDocumentNotReadyMsg: 'Veuillez patienter que le document soit prêt',
		exportFailed: "L'export a échoué",
		tooManyRequests: 'Vous effectuez trop de requêtes, veuillez réessayer plus tard',
		sttError: 'Erreur lors de la transcription vocale',
		microphoneAccess: 'Accès au microphone refusé, veuillez réessayer',
		required: 'Ce champ est obligatoire',
		field_required: 'Veuillez remplir le champ obligatoire',
		all_fields_required: 'Veuillez remplir tous les champs obligatoires pour continuer',
		inviteError: "Une erreur est survenue lors de l'acceptation de l'invitation"
	},
	footer: {
		resourcesTitle: 'Ressources',
		pricing: 'Tarifs',
		news: 'Actualités',
		docs: 'Documentation',
		devApi: 'API développeurs',
		cgu: 'Conditions',
		cgv: 'CGV',
		privacy: 'Confidentialité',
		privacyPolicy: 'Politique de confidentialité',
		press: 'Presse',
		contactUs: 'Contactez-nous',
		needHelp: "Besoin d'aide ?",
		joinUs: 'Rejoignez-nous',
		followUs: 'Suivez-nous',
		rights: 'Tous droits réservés.',
		generalConditions: "Conditions générales d'utilisation",
		salesConditions: 'Conditions générales de vente',
		publicRelation: 'Relation Presse'
	},
	home: {
		home: 'Accueil',
		about: 'À propos',
		app: 'Utiliser notre IA',
		news: 'Actualités',
		aboutOrdalie: "À propos d'Ordalie",
		aboutOrdalieMsg1: "Aujourd'hui, Ordalie est en beta.",
		aboutOrdalieMsg2:
			'Cela signifie que vous pouvez utiliser le service gratuitement, mais que vous êtes limités à 10 messages/semaine à notre IA.',
		aboutOrdalieMsg3:
			'Le projet avance vite, nous intégrerons bientôt davantage de fonctionnalités ainsi que de nouvelles sources juridiques (conventions collectives, règlements UE, etc.)',
		aboutOrdalieMsg4: 'Le projet est principalement mené par ',
		titleOfLea: 'juriste et data-analyst',
		titleOfBaudouin: 'développeur full-stack et data-scientist'
	},
	news: {
		dailyNews: 'La nouveautés du jour',
		lastNews: 'Dernières actualités'
	},
	info: {
		share: 'Partager',
		loadingShortMsg: 'chargement',
		loading: 'Chargement...',
		loadingDocumentation: 'Chargement de la documentation...',
		lastUpdatedOn: 'Dernière mise à jour le',
		tableOfContents: 'Table des matières',
		docsExploreGuides:
			'Ordalie fait plein de choses, mais ça peut vite devenir un peu abstrait. Alors on vous a préparé cette documentation pour vous aider à en tirer le meilleur parti. Et si jamais vous avez une question, on est là !',
		docsClickToExplore: 'Cliquez pour explorer cette section',
		docsMoreSubsections: '+ {count} de plus',
		docsSubSections: 'sous-sections',
		docsExploreDocumentation: 'Explorer la documentation',
		confirm: 'Confirmer',
		cancel: 'Annuler',
		searching: 'Posez votre question ou formulez une requête...',
		search: 'Rechercher',
		send: 'Envoyer',
		sending: 'Envoi...',
		answer: 'Répondre...',
		thanksForFeedback: 'Merci pour votre retour !',
		yourOpinionIsImportant: 'Votre avis compte !',
		continue: 'Continuer',
		add: 'Ajouter',
		link: 'Lien',
		openLink: 'Ouvrir le lien',
		openFile: 'Ouvrir le fichier',
		openPage: 'Accéder à la page',
		openLegifrance: "Accéder à l'article sur Legifrance",
		openEurLex: "Accéder à l'article sur Eur-Lex",
		delete: 'Supprimer',
		return: 'Retour',
		copy: 'Copier',
		close: 'Fermer',
		copied: 'Texte copié',
		copiedIntoClipboard: 'Texte copié dans le presse-papier',
		download: 'Télécharger',
		downloading: 'Téléchargement...',
		previous: 'Précédent',
		next: 'Suivant',
		redo: 'Refaire',
		canceledImport: 'Import bien annulé',
		anonymize: 'Anonymiser',
		anonymizing: 'Anonymisation en cours...',
		singleFileImported: '1 fichier importé',
		multipleFilesImported: ' fichiers importés',
		seeMore: 'Voir plus',
		start: 'Démarrer',
		finish: 'Terminer',
		tryAgain: 'Réessayer',
		refresh: 'Actualiser',
		or: 'ou',
		sendButton: "Bouton d'envoi",
		minimize: 'Réduire',
		inProgress: 'En cours...',
		update: 'Mettre à jour',
		save: 'Enregistrer',
		date: 'Date',
		maintenanceMsg1: 'Ordalie est en maintenance.',
		maintenanceMsg2: 'Nous revenons très vite ! 👩🏼‍💻',
		dateFilterAvailableSoon: 'Le filtre par date arrive bientôt !',
		availableSoon: 'Bientôt disponible !',
		processingDocument: 'Ce document est en cours de traitement',
		generate: 'Générer',
		open: 'Ouvrir',
		hide: 'Masquer',
		comment: 'Commentaire',
		optional: 'optionnel',
		generating: 'Génération...',
		regenerate: 'Re-générer',
		clickToAccess: 'Cliquez pour accéder',
		export: 'Exporter',
		startRecording: "Démarrer l'enregistrement",
		stopRecording: "Arrêter l'enregistrement",
		generationInProgress: 'Génération du document en cours...',
		more: 'Plus...',
		selected: 'Sélectionné',
		generationComplete: 'Génération du document terminée !',
		sortAlphabetically: 'Trier par ordre alphabétique',
		sortByCount: 'Trier par nombre',
		sortByRecent: 'Trier par récent',
		sortLabelAlphabetical: 'A-Z',
		sortLabelCount: 'Nombre',
		sortLabelRecent: 'Récent'
	},
	vault: {
		whatIsOrdalieVault: "Qu'est-ce qu'Ordalie Vault ?",
		aboutVaultmsg1: ' est un serveur sécurisé connecté à la base de connaissances interne de ',
		aboutVaultmsg2: 'Les documents internes viennent compléter les ',
		aboutVaultmsg3: 'millions de sources',
		aboutVaultmsg4: " d'Ordalie pour décupler la puissance et la pertinence de nos modèles d'IA.",
		aboutVaultmsg5: 'Vous bénéficiez notamment de :',
		aboutVaultmsg6: 'Recherches juridiques appuyées sur votre knowledge interne',
		aboutVaultmsg7: 'Aide à la rédaction de contrats grâce à votre historique de clauses',
		aboutVaultmsg8: 'Nombreuses autres fonctionnalités à venir...',
		aboutVaultmsg9: "Pour toute question, un support dédié est disponible à l'adresse : ",
		connecting: 'Connexion en cours...',
		connectedTo: 'Connecté à ',
		disconnectedFrom: 'Déconnecté de ',
		syncedDocuments: ' documents synchronisés',
		currentlyUnavailable: 'actuellement indisponible',
		description:
			"Ordalie Vault est un module on-premise qui connecte Ordalie à votre SI et valorise vos données internes. Profitez d'une recherche avancée, de suggestions personnalisées et d'une génération de documents fluide, directement depuis vos sources."
	},
	onboarding: {
		welcomeToOrdalie: 'Bienvenue sur Ordalie',
		askForName: 'Quel est votre nom ?',
		askForCompanySize: 'Quelle est la taille de votre entreprise ?',
		askForActivity: 'Quelle est votre activité ?',
		askForActivityMsg: 'Cela me permettra de vous apporter des réponses plus pertinentes',
		finalMsg: 'Tout est prêt !',
		useOrdalie: 'Commencer à utiliser Ordalie',
		activityPlaceholder1: 'Je suis avocat spécialisé en droit des affaires...',
		activityPlaceholder2: "Je suis chef d'entreprise dans le secteur technologique...",
		singlePerson: 'personne',
		multiplePeople: 'personnes',
		loadingData: 'Chargement de vos données',
		finalizingProfile: 'Finalisation de votre profil',
		privacyTitle: 'La protection de vos données est notre priorité',
		privacyHosting: {
			title: 'Hébergement 100% français',
			content:
				'Vos données sont hébergées exclusivement en France sur des serveurs sécurisés et certifiés.'
		},
		privacyGDPR: {
			title: 'Conformité RGPD',
			content:
				'Nous respectons scrupuleusement le RGPD et vos droits. Vous gardez le contrôle total de vos données.'
		},
		privacyNoReuse: {
			title: 'Pas de réutilisation des données',
			content:
				"Vos données ne sont jamais utilisées pour entraîner nos modèles d'IA. Elles restent strictement confidentielles."
		},
		privacyConsent: "Je comprends et j'accepte que mes données soient traitées conformément à la",
		privacyPolicy: 'politique de confidentialité'
	},
	faq: {
		question1: 'Comment fonctionne Ordalie ?',
		answer1:
			"Ordalie utilise une technologie d'IA pour lire et comprendre les articles de la loi française, afin de répondre à vos questions sur le droit.",
		question2: "Puis-je faire confiance aux réponses d'Ordalie ?",
		answer2:
			'Ordalie est entraîné avec des données juridiques fiables et actualisées, mais il est toujours recommandé de consulter un avocat pour des conseils personnalisés.',
		question3: "Est-ce que les réponses d'Ordalie sont gratuites ?",
		answer3:
			'Oui, les réponses sont actuellement gratuites pour tous les utilisateurs, dans la limite de 10 par semaine.',
		question4: 'Comment puis-je contacter Ordalie ?',
		answer4: "Vous pouvez contacter l'équipe derrière Ordalie à l'adresse support@ordalie.tech",
		question5: 'Est-ce que les informations que je partage avec Ordalie sont protégées ?',
		answer5:
			"Oui, nous prenons très au sérieux la confidentialité de vos informations. Veuillez consulter notre <a class='underline' href='/legal/cgu' target='_blank' rel='noreferrer'>conditions générales d'utilisation</a> pour plus de détails sur la manière dont nous protégeons vos données."
	},
	training: {
		title: 'Découvrez Ordalie',
		subtitle:
			"Suivez différentes missions pour apprendre à exploiter au maximum la puissance des fonctionnalités d'Ordalie.",
		addPoint: 'points !',
		missionCompleted1: 'Mission',
		missionCompleted2: 'complétée !',
		completed1: 'Complétée !',
		completed2: 'Fait !',
		completed3: 'Terminé !',
		introCat: 'Démarrez sur Ordalie',
		intro1title: 'Créez votre compte Ordalie',
		intro1desc:
			"Créez un compte sur Ordalie pour accéder à toutes les fonctionnalités de la plateforme. À priori, si vous lisez ceci, c'est que vous avez déjà validé cette tâche ! 🎉 <br> Continuez comme ça !",
		intro2title: 'Renseigner la description de votre profil',
		intro2desc:
			'La description du profil permettra à Ordalie de mieux adapter ses réponses à vos besoins. Vous pouvez la modifier à tout moment dans les <a href="/settings">paramètres</a> de votre compte avec le bouton "Modifier mon profil".',
		rechCat: 'Utilisation du chat',
		rech1title: 'Effectuez une recherche dans le chat',
		rech1desc:
			'Posez une question juridique dans la partie <a href="/app/chat">chat</a> et obtenez une réponse. Ordalie vous répondra directement si la questions est suffisamment précise, en citant toutes les sources consultées pour vous donner une réponse fondée en droit. Si la question est trop vague, Ordalie vous demandera des précisions pour affiner sa réponse.',
		rech2title: 'Ajoutez un document en contexte',
		rech2desc:
			'Vous pouvez ajouter un document en contexte dans le chat pour poser une question sur un document spécifique. Pour cela, cliquez sur le bouton "+" à gauche du champs de saisie du chat et sélectionnez le document à ajouter.',
		rech3title: 'Générez un document juridique via le chat',
		rech3desc:
			'Le chat vous permet également de générer des documents basés sur le contexte de votre conversation ! Pour cela, il vous suffit simplement de demander à Ordalie de générer un document en précisant au maximum le résultat souhaité. Plus vous êtes précis, meilleur sera le résultat !',
		rech4title: 'Chargez une ancienne conversation',
		rech4desc:
			"Chargez une ancienne conversation à partir de l'historique du chat. Le bouton se trouve en haut à droite de la fenêtre de chat.",
		notesCat: 'Gérez vos notes',
		notes1title: 'Ajoutez une note',
		notes1desc:
			"Affichez une des sources (article, jurisprudence...) issues de vos recherches puis cliquez sur l'icône 📎 en haut à droite de la mini-fenêtre. Vous pouvez également y ajouter un commentaire ainsi qu'un tag pour une meilleure organisation.",
		notes2title: 'Retrouvez et consultez vos notes',
		notes2desc:
			'Enfin, retrouvez toutes vos notes dans la section <a href="/app/search">notes</a> de votre compte.',
		docsCat: 'Gérez vos documents',
		docs1title: 'Importez un document',
		docs1desc:
			"Importez n'importe quel document dans Ordalie — tous les formats sont acceptés (pdf, docx, jpeg...) ! Vous pourrez ainsi les ajouter aux sources, les analyser ou mêmes les modifier grâce à l'IA.",
		docs2title: 'Utilisez un document importé comme source',
		docs2desc:
			"Complétez les millions de sources déjà disponibles sur Ordalie en ajoutant vos propres documents importés ! Vous pourrez ainsi les utiliser dans vos recherches et les citer dans vos documents générés. <br> Les documents sont importés dans un espace complètement cloisonné et sécurisé, et ne sont jamais partagés avec d'autres utilisateurs 🔒",
		docs2video: 'tutorial_medias/docs2.mp4',
		analyseCat: 'Analysez vos documents',
		analyse1title: 'Résumez un document importé',
		analyse1desc:
			"Utilisez la fonctionnalité de résumé pour obtenir un aperçu concis d'un document importé. Vous avez le choix entre 4 niveaux de complexité, selon vos besoins !",
		analyse1video: 'tutorial_medias/analyse1.mp4',
		analyse2title: 'Analysez un document importé',
		analyse2desc:
			"Utilisez les outils d'analyse pour étudier un document importé (conformité, extraction de dates, questions spécifiques). Ordalie citera les lignes du document qui ont été utilisées pour répondre à vos questions.",
		analyse2video: 'tutorial_medias/analyse2.mp4',
		genCat: 'Rédaction assistée par IA',
		gen1title: 'Générez un document',
		gen1desc:
			"Utilisez le bouton de génération pour créer un contrat ou un document juridique à partir de rien. Vous pouvez également ajouter jusqu'à 3 documents de référénce pour guider l'IA dans sa rédaction. <br> Plus vous serez précis dans votre demande, meilleur sera le résultat !",
		gen1video: 'tutorial_medias/gen1.mp4',
		gen2title: "Reformulez un passage d'un document",
		gen2desc:
			"Utilisez la fonctionnalité de reformulation pour modifier un passage d'un document existant par surlignage. Plusieurs boutons d'accès rapide sont disponibles pour vous aider à reformuler rapidement de plusieurs façons.",
		gen2video: 'tutorial_medias/gen2.mp4',
		gen3title: 'Générez un nouveau passage dans un document',
		gen3desc:
			'Utilisez la fonctionnalité de génération pour ajouter un nouveau passage à un document existant. Plus vous serez précis dans votre demande, meilleur sera le résultat !',
		gen4title: 'Générez à partir de vos passages similaires',
		gen4desc:
			'Ordalie vous permet de générer ou réécrire un passage à partir d\'autres passages similaires trouvés dans vos documents importés. <br> Pour cela, sélectionnez un passage et cliquez sur le bouton "Rechercher des passages similaires". Vous aurez ensuite la possibilité de naviguer à travers les différents passages trouvés de vos contrats et sélectionner celui qui vous convient le mieux pour effectuer la génération.',
		gen4video: 'tutorial_medias/gen4.mp4',
		sourceCat: 'Gérez vos sources',
		source1title: 'Ajoutez des sites internet aux sources',
		source1desc:
			'Ajoutez des sites internet dans les sources d\'Ordalie pour les utiliser comme référence lors de vos recherches et analyses juridiques. <br> Pour cela, accédez à <a href="/settings">"Mon compte"</a>, cliquez sur le bouton "Gérer les sources" et ajoutez une nouvelle source en cliquant sur le bouton "Ajouter" sous la section "Sites internet".<br> En version gratuite, vous êtes limités à 2 sites internet indexés.',
		source2title: 'Activez/désactivez des sources juridiques',
		source2desc:
			'Modifiez les sources juridiques internes fournies par Ordalie. <br> Pour cela, accédez à <a href="/settings">"Mon compte"</a>, cliquez sur le bouton "Gérer les sources" et sélectionnez les sources que vous souhaitez désactiver ou activer.',
		compteCat: 'Gérez votre compte Ordalie',
		compte1title: 'Récupérez vos factures',
		compte1desc:
			"Accédez à l'historique de vos factures et gérer vos abonnements grâce au bouton intitulé <i>Mon compte client</i> dans la section <a href='/app/settings'>compte</a>.<br> Ce bouton vous redirigera vers la page de gestion de votre compte client sur une plateforme sécurisée de notre partenaire Stripe.",
		compte1video: 'tutorial_medias/compte1.mp4'
	},
	config: {
		editTitleOrContent:
			'Vous pouvez éditer les titres/contenus des sections ou bien les réordonner.'
	},
	legal: {
		title: 'Mentions légales',
		termsOfService: "Conditions Générales d'Utilisation",
		privacyPolicy: 'Politique de Confidentialité',
		termsOfSale: 'Conditions Générales de Vente',
		cgu: "Conditions Générales d'Utilisation",
		privacy: 'Politique de Confidentialité',
		cgv: 'Conditions Générales de Vente'
	},
	wordalie: {
		views: 'Affichage',
		file: 'Fichier',
		font: 'Police',
		paragraph: 'Paragraphe',
		styling: 'Style',
		comment: 'Commentaire',
		edit: 'Édition',
		voice: 'Voix',
		aiTools: 'Outils IA',
		tools: 'Outils',
		download: 'Télécharger',
		undo: 'Annuler',
		redo: 'Rétablir',
		bold: 'Gras',
		italic: 'Italique',
		underline: 'Souligné',
		strike: 'Barré',
		bulletList: 'Liste à puces',
		numberedList: 'Liste numérotée',
		showComments: 'Commentaires',
		newComment: 'Nouveau commentaire',
		trackChanges: 'Suivi des modifications',
		dictate: 'Dicter',
		aiWriting: 'Écriture IA',
		align: 'Alignement',
		alignLeft: 'Aligner à gauche',
		alignCenter: 'Centrer',
		alignRight: 'Aligner à droite',
		alignJustify: 'Justifier',
		indent: 'Augmenter le retrait',
		outdent: 'Diminuer le retrait',
		saving: 'Enregistrement...',
		saved: 'Enregistré',
		saveFile: 'Enregistrer le fichier',
		added: 'Ajouté',
		removed: 'Supprimé',
		replaced: 'Remplacé',
		with: 'par',
		openInEditor: "Ouvrir dans l'éditeur",
		acceptAllChanges: 'Accepter toutes les modif.',
		rejectAllChanges: 'Rejeter les modif.'
	},
	security: {
		title: 'Mesures de sécurité',
		info: 'Informations de sécurité',
		dataLocation: 'Toutes les données hébergées exclusivement en France',
		encryption: 'Flux de données et stockage chiffrés de bout en bout',
		lastAuditDate: 'Dernier audit de sécurité :',
		noDataReuse: "Aucune réutilisation des données pour l'IA ou des tiers",
		trustCenter: 'Centre de confiance'
	},
	actions: {
		edit: 'Modifier',
		cancel: 'Annuler',
		save: 'Enregistrer',
		remove: 'Retirer',
		invite: 'Inviter',
		sending: 'Envoi en cours...',
		loading: 'Chargement...',
		creating: 'Création en cours...',
		createOrganization: 'Créer une organisation',
		addEmail: 'Ajouter un email',
		subscribe: "S'abonner"
	},
	share: {
		share: 'Partager',
		teamMembers: "Membres de l'équipe",
		inviteByEmail: 'Inviter par email',
		public: 'Public',
		emailAddress: 'Adresse email',
		enterEmailPlaceholder: 'Entrez une adresse email',
		searchMembersPlaceholder: 'Rechercher des membres...',
		unnamedUser: 'Utilisateur sans nom',
		noMembersFound: 'Aucun membre trouvé',
		searchMembers: "Rechercher des membres de l'équipe",
		noOrgMembers: "Aucun membre dans l'organisation",
		publicShareInfo: 'Toute personne disposant du lien peut accéder à ce contenu',
		accessLevel: "Niveau d'accès",
		view: 'Lecteur',
		edit: 'Éditeur',
		publicAccess: 'Accès public',
		sharing: 'Partage en cours',
		whoHasAccess: 'Qui a accès',
		organization: 'Organisation',
		unknownUser: 'Utilisateur inconnu',
		removeAccessFor: "Retirer l'accès pour {target}",
		shareSuccess: 'Partage effectué avec succès',
		removeSuccess: 'Accès retiré avec succès',
		errorLoadingShares: 'Erreur lors du chargement des partages',
		errorLoadingMembers: "Erreur lors du chargement des membres de l'équipe"
	},
	cookies: {
		bannerTitle: 'Salut ! 🍪',
		bannerDescription: 'On a attendu d\'être sûrs que vous vous intéressiez à ce qu\'offre Ordalie avant de parler de cookies. On les utilise pour vous garder connecté et comprendre comment améliorer notre plateforme. Vos données restent en France et ne sont jamais partagées avec des tiers.',
		bannerQuestion: 'Ça vous va ?',
		cookiePurposeTitle: 'Usage :',
		cookiePurposeList: 'Gestion de session et maintien de la connexion;Analyses d\'usage pour l\'amélioration de la plateforme',
		customizeButton: 'Je choisis',
		rejectButton: 'Non merci',
		acceptAllButton: 'Ok pour moi',
		preferencesTitle: 'Préférences des cookies',
		closeDetailsLabel: 'Fermer les détails',
		essentialCookiesTitle: 'Cookies essentiels',
		essentialCookiesDescription: 'Ceux-là vous gardent connecté et font qu\'Ordalie fonctionne bien. On ne peut pas les désactiver.',
		analyticsCookiesTitle: 'Cookies d\'analyse',
		analyticsCookiesDescription: 'Ils nous aident à comprendre ce que vous trouvez utile pour rendre Ordalie encore mieux pour les juristes comme vous.',
		rejectAllButton: 'Refuser tout',
		savePreferencesButton: 'Sauvegarder les préférences',
		privacyPolicyText: 'En continuant à utiliser notre site, vous acceptez notre',
		privacyPolicyLink: 'politique de confidentialité',
		preferencesSuccess: 'Préférences enregistrées',
		settingsTitle: 'Gestion des cookies',
		settingsDescription: 'Gérez vos préférences de cookies pour personnaliser votre expérience tout en respectant votre vie privée.',
		essentialSettingsDescription: 'Cookies nécessaires au fonctionnement du site (authentification, sécurité, préférences)',
		analyticsSettingsDescription: 'Collecte d\'usage anonyme, suivi des erreurs et mesure des performances pour améliorer notre service',
		alwaysEnabled: 'Toujours activés',
		enabled: 'Activés',
		disabled: 'Désactivés',
		activeServices: 'Services actifs : analyse comportementale, détection d\'erreurs, métriques de performance',
		lastUpdated: 'Dernière mise à jour',
		version: 'Version',
		toggleLabel: 'Basculer les cookies d\'analyse',
		analyticsEnabled: 'Cookies d\'analyse activés',
		analyticsDisabled: 'Cookies d\'analyse désactivés'
	}
};

export default translations;
